/** Access token lives only in memory; the refresh token is an HttpOnly cookie the browser sends to /auth. */
let accessToken: string | null = null;
const listeners = new Set<(token: string | null) => void>();

export const authStore = {
  get token(): string | null {
    return accessToken;
  },
  set(token: string | null): void {
    accessToken = token;
    for (const listener of listeners) listener(token);
  },
  subscribe(listener: (token: string | null) => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
